/** ヘッダーナビの「現在ページ」ハイライト用。ティア表は / のみ一致とする。 */
export function isNavLinkActive(pathname: string, linkTo: string): boolean {
  if (linkTo === '/') {
    return pathname === '/';
  }
  return pathname === linkTo;
}
